module.exports = __webpack_public_path__ + "ed8100f95e1c7c5d1df104b47b01a302.svg";